import type {
  BillingAccountResponse,
  BillingPlansResponse,
  CreateBillingAccountRequest,
  CreateBillingAccountResponse,
  CreateCheckoutRequest,
  CreateCheckoutResponse,
  CreatePortalRequest,
  CreatePortalResponse,
  CreditBalanceResponse,
} from "@/types";
import { ApiError } from "@/services/api/errors";
import { request } from "@/services/api/request";

export async function getBillingPlans(): Promise<BillingPlansResponse> {
  return request<BillingPlansResponse>("/billing/plans");
}

export async function getBillingAccount(): Promise<BillingAccountResponse> {
  return request<BillingAccountResponse>("/billing/account");
}

export async function createBillingAccount(
  data: CreateBillingAccountRequest,
): Promise<CreateBillingAccountResponse> {
  return request<CreateBillingAccountResponse>("/billing/account", {
    method: "POST",
    body: data as unknown as Record<string, unknown>,
    contentType: "json",
  });
}

export async function createCheckoutSession(
  data: CreateCheckoutRequest,
): Promise<CreateCheckoutResponse> {
  return request<CreateCheckoutResponse>("/billing/checkout", {
    method: "POST",
    body: data as unknown as Record<string, unknown>,
    contentType: "json",
  });
}

export async function createPortalSession(
  data?: CreatePortalRequest,
): Promise<CreatePortalResponse> {
  return request<CreatePortalResponse>("/billing/portal", {
    method: "POST",
    body: data || {},
    contentType: "json",
  });
}

export async function redirectToCheckout(data: CreateCheckoutRequest): Promise<void> {
  const { checkoutUrl } = await createCheckoutSession(data);
  if (!checkoutUrl || typeof checkoutUrl !== "string") {
    throw new ApiError("Checkout session URL not provided", 500);
  }
  globalThis.location.href = checkoutUrl;
}

export async function redirectToPortal(): Promise<void> {
  const { portalUrl } = await createPortalSession();
  if (!portalUrl || typeof portalUrl !== "string") {
    throw new ApiError("Portal session URL not provided", 500);
  }
  globalThis.location.href = portalUrl;
}

export async function getCreditBalance(): Promise<CreditBalanceResponse> {
  return request<CreditBalanceResponse>("/billing/credits");
}
